import clsx from "clsx";
import { IconProps } from "../../types/icons";
import { createColorClasses } from "@/theme/colors";

import { WithVariant } from "@/types/variant";

export const FseOperators = ({
    width = 44,
    height = 44,
    className,
    color,
    decorative = false,
    ariaLabel = "FSE",
}: WithVariant<IconProps>) => {
    const classes = createColorClasses({ color });

    return (
        <svg width={width} height={height} viewBox="0 0 28 44" fill="currentColor" xmlns="http://www.w3.org/2000/svg" className={clsx(className, classes)} aria-hidden={decorative} aria-label={!decorative ? ariaLabel : undefined}>
            <g clipPath="url(#clip0_11651_4620)">
                <path d="M24.1774 44H25.2051V35.1843H24.1774V44Z" fill="#009640" />
                <path d="M25.2086 44H26.2363V32.828H25.2086V44Z" fill="#F5F5F5" />
                <path d="M26.6431 43.9962H26.2363V30.4297H27.264V43.3753C27.264 43.7183 26.9861 43.9962 26.6431 43.9962Z" fill="#E30613" />
                <path d="M25.7152 6.35547H13.4875V9.42324H10.4223V17.312H1.53388C0.687252 17.312 0 17.998 0 18.8459V31.8335C0 32.6801 0.685977 33.3674 1.53388 33.3674H10.5791V42.3348C10.5791 43.1815 11.2651 43.8687 12.113 43.8687H23.035V40.8022H13.6469V31.8348C13.6469 30.9882 12.9609 30.3009 12.113 30.3009H3.06777V20.381H11.9561C12.8028 20.381 13.49 19.695 13.49 18.8471V9.42324H24.1826V20.3899H27.2491V7.88935C27.2491 7.04145 26.5618 6.35547 25.7152 6.35547Z" fill="white" />
                <path opacity="0.75" d="M10.418 6.48828H7.34766V9.5586H10.418V6.48828Z" fill="#F5F5F5" />
                <path d="M13.4902 3.41406H10.4199V6.48438H13.4902V3.41406Z" fill="white" />
                <path opacity="0.75" d="M7.5181 0H4.10352V3.41458H7.5181V0Z" fill="#F5F5F5" />
                <path opacity="0.5" d="M4.08143 3.96875H1.53516V6.51502H4.08143V3.96875Z" fill="#ECECEC" />
                <path opacity="0.4" d="M4.0806 9.55469H0.666016V12.9693H4.0806V9.55469Z" fill="#E8E8E8" />
            </g>
            <defs>
                <clipPath id="clip0_11651_4620">
                    <rect width="27.26" height="44" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

